import type { TNetworkError } from '@/services/errors';
import type { TStreamCredentialsDTO } from './chat.dto';

import { BaseService } from '@/services/api';
import { errorUtils } from '@/services/errors';
import { withSessionHeaders } from '@/services/supabase';

import type { TStreamCredentials } from './chat.types';

import { toStreamCredentials } from './chat.adapters';

const CHAT_TOKEN_PATH = '/chat-token';

class ChatService extends BaseService {
  protected readonly serviceName = 'chatService';

  public async readCredentials(): Promise<TStreamCredentials | TNetworkError> {
    const payload = await this.post<TStreamCredentialsDTO, Record<string, never>>(
      CHAT_TOKEN_PATH,
      {},
      { where: 'readCredentials', headers: await withSessionHeaders() },
    );

    if (errorUtils.isNetworkError(payload)) {
      return payload;
    }

    return toStreamCredentials(payload);
  }
}

const chatService = new ChatService();

export {
  chatService,
};
